/**
 * Divider — a hairline rule between content bands. Trivial, but a primitive so
 * every block (including `divider`) dispatches uniformly from the block registry.
 */
export interface DividerProps {}

export function Divider(_props: DividerProps) {
  return <hr className="border-border" />;
}
